import React, { createContext, FC, ReactNode, useState } from 'react';

import { NoteTag } from '../types/api.graphql';

export enum VDPTabType {
  Summary = 'summary',
  Integrations = 'integrations',
  Activity = 'activity',
  Notes = 'notes',
  History = 'history',
  Documents = 'documents',
  Expenses = 'expenses',
  More = 'more',
}

interface VDPContextProps {
  isVDPNavigationBarVisible: boolean;
  setIsVDPNavigationBarVisible: React.Dispatch<React.SetStateAction<boolean>>;
  selectedMobileTab?: VDPTabType;
  setSelectedMobileTab?: React.Dispatch<React.SetStateAction<VDPTabType>>;
  selectedNotesTagFilter: NoteTag;
  setSelectedNotesTagFilter: React.Dispatch<React.SetStateAction<NoteTag>>;
}

interface VDPProviderProps {
  children: ReactNode;
}

const VDPContext = createContext<VDPContextProps>({
  isVDPNavigationBarVisible: null,
  setIsVDPNavigationBarVisible: undefined,
  selectedMobileTab: null,
  setSelectedMobileTab: undefined,
  selectedNotesTagFilter: null,
  setSelectedNotesTagFilter: undefined,
});

export const VDPProvider: FC<VDPProviderProps> = ({ children }) => {
  const [isVDPNavigationBarVisible, setIsVDPNavigationBarVisible] = useState(true);
  const [selectedMobileTab, setSelectedMobileTab] = useState<VDPTabType>(VDPTabType.Summary);

  // When null, "all" option is selected.
  const [selectedNotesTagFilter, setSelectedNotesTagFilter] = useState(null);

  return (
    <VDPContext.Provider
      value={{
        isVDPNavigationBarVisible,
        setIsVDPNavigationBarVisible,
        selectedMobileTab,
        setSelectedMobileTab,
        selectedNotesTagFilter,
        setSelectedNotesTagFilter,
      }}
    >
      {children}
    </VDPContext.Provider>
  );
};

export const useVDPContext: () => VDPContextProps = () => {
  return React.useContext(VDPContext);
};
